export const API_BASE_URL = process.env.NODE_ENV === 'production' ? 
  'https://dash-streaming-backend.onrender.com' :
  'http://localhost:5000';